import { useEffect } from "react";
import { parentOriginFromLocation, postMessageToParentFrame } from "@/lib/parentFrame";

export function useNotifyHostComposerDismiss() {
    useEffect(function notifyParentWhenThreadIsPressed() {
        const parentOrigin = parentOriginFromLocation();
        if (!parentOrigin) {
            return;
        }

        function handleClick() {
            postMessageToParentFrame(parentOrigin, {
                type: "chat.composer.dismiss",
            });
        }

        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, []);
}
